import React from 'react';

export default function ExperienceSection({ t, language }) {
  return (
    <section className="w-full px-0 flex items-stretch bg-white">
      <div className="grid grid-cols-1 md:grid-cols-2 w-full min-h-[20rem]">
        {/* Left: Full-bleed Image */}
        <div className="h-full w-full">
          <img
            src="/images/dress.jpg"
            alt={language === 'en' ? t.experience.theAssemblageExperience : t.experience.theAssemblageExperience}
            className="w-full h-full object-cover object-[60%] rounded-none shadow-xl"
          />
        </div>
        {/* Right: Content */}
        <div className="flex flex-col justify-center px-12 md:px-32 py-8 md:py-12 max-w-3xl w-full mx-auto h-full">
          <h2 className="text-xl md:text-2xl font-playfair mb-4 text-[#181c24] font-semibold leading-tight">
            {language === 'es' ? (
              <>
                La Experiencia{' '}
                <span className="relative inline-block" style={{ marginBottom: '0.15em' }}>
                  Assemblage
                  <span
                    className="block absolute left-0 right-0 h-0.5 bg-[#bfa76a] rounded-full"
                    style={{ bottom: '-0.22em' }}
                  ></span>
                </span>
              </>
            ) : (
              <>
                The{' '}
                <span className="relative inline-block" style={{ marginBottom: '0.15em' }}>
                  Assemblage
                  <span
                    className="block absolute left-0 right-0 h-0.5 bg-[#bfa76a] rounded-full"
                    style={{ bottom: '-0.22em' }}
                  ></span>
                </span>
                <br className="block md:hidden" />
                <span className="md:inline hidden"> Experience</span>
                <span className="md:hidden inline">Experience</span>
              </>
            )}
          </h2>
          <span className="italic text-[#bfa76a] text-sm block mb-2">
            {t.experience.seamlessPlanningText}
          </span>
          <div>
            <br/>
          </div>
          <div className="flex flex-col gap-8 md:pl-0 justify-center text-xs">
            {[
              {
                icon: '✨',
                title: t.experience.AssemblageDesign,
                text: t.experience.AssemblageDesignText
              },
              {
                icon: '🌿',
                title: t.experience.localExpertise,
                text: t.experience.localExpertiseText
              },
              {
                icon: '🕊',
                title: t.experience.seamlessPlanning,
                text: t.experience.seamlessPlanningText
              },
              {
                icon: '📸',
                title: t.experience.memories,
                text: t.experience.memoriesText
              }
            ].map((item, i, arr) => (
              <div key={i} className="flex items-start gap-4 fade-in mb-8">
                <span className="flex items-center justify-center w-10 h-10 rounded-full bg-[#bfa76a]/10 border-2 border-[#bfa76a] text-xl text-[#bfa76a] shadow-sm">
                  {item.icon}
                </span>
                <div className="flex-1">
                  <h3 className="text-sm font-playfair font-bold text-[#181c24] mb-1 flex items-center gap-2">
                    {item.title}
                    <span className="block w-8 h-0.5 bg-[#bfa76a] rounded-full ml-2" />
                  </h3>
                  <p className="text-[#181c24]/60 leading-relaxed text-xs font-light mb-0.5 md:mb-0">
                    {item.text}
                  </p>
                  {i < arr.length - 1 && (
                    <div className="h-0.5 w-12 bg-[#bfa76a]/30 rounded-full mt-5 mb-0" />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
} 